import React, { Fragment, useState } from "react";
import Breadcrumb from "../../commons/breadcrumb/breadcrumb";
import "./contact.css";
import Input from "../../commons/input/input";
import Button from "../../commons/button/button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GoogleMap from "../../commons/googlemap/googlemap";
const Contact = () => {
  const [sendBtnStyle, setSendBtnStyle] = useState({
    boxshadow: "",
    //
    background: "#b2bec3",
    cursor: "context-menu",
    tooltip: "لطفا ابتدا فرم را بطور کامل ، پر کنید",
  });

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [text, setText] = useState("");
  const [formOk, setFormOk] = useState(false);

  const textHandler = (e) => {
    setText(e.target.value);
    console.log(text);

    FormValidate();
  };
  const FormValidate = () => {
    if (fullName.length > 2 && email.length > 2 && text.length > 2) {
      let prevState = { ...sendBtnStyle };
      prevState.boxshadow = "0px 0px 13px -3px #636e72";
      prevState.background = "#a5c926";
      prevState.cursor = "pointer";
      prevState.tooltip =
        "پیفام ارسالی حداکثر تا 24 ساعت بررسی و پاسخ داده خواهد شد";
      setSendBtnStyle(prevState);
      setFormOk(true);
    } else {
      let prevState2 = {
        boxshadow: "",
        background: "#b2bec3",
        cursor: "context-menu",
        tooltip: "لطفا ابتدا فرم را بطور کامل ، پر کنید",
      };

      setSendBtnStyle(prevState2);
      setFormOk(false);
    }
  };

  const sendFormHandler = () => {
    if (formOk) {
      toast.success(
        <h6 style={{ textAlign: "right", fontFamily: "Iransans" }}>
          پیغام با موفقیت ارسال شد.
        </h6>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setFullName("");
      setEmail("");
      setText("");
      setFormOk(false);
      let prevState2 = {
        boxshadow: "",
        background: "#b2bec3",
        cursor: "context-menu",
        tooltip: "لطفا ابتدا فرم را بطور کامل ، پر کنید",
      };

      setSendBtnStyle(prevState2);
    }
  };

  return (
    <Fragment>
      <div className="container-fluid contact_page_body">
        <div className="container page_body">
          <Breadcrumb bread2="تماس با ما" />
          <div className="contact_body">
            <div className="row">
              <div className="googlemap_body col-xs-12 col-sm-12 sol-md-12 col-lg-12 col-xl-12">
                <GoogleMap width="98%" height="300px" />
              </div>
            </div>
            <div className="row bottom_row">
              <div className="col-xs-12 col-sm-12 sol-md-6 col-lg-6 col-xl-6">
                <dvi className="info_sec_body">
                  <h4 className="info_sec_title">اطلاعات تماس</h4>
                  <div className="info_sec_address">
                    قم ، خیابان دورشهر ، برج سفید ، طبقه 4 پلاک 130{" "}
                  </div>
                  <div className="info_sec_phone">09129211290</div>
                  <div className="info_sec_email">Info@Aroosaki.com</div>
                  <div className="info_sec_icons_title">
                    ما را در شبکه های اجتماعی دنبال کنید
                  </div>
                  <div className="info_sec_icons_body">
                    <img
                      src="https://s18.picofile.com/file/8440286068/1.jpg"
                      className="info_social_icon"
                    />
                    <img
                      src="https://s18.picofile.com/file/8440286092/2.jpg"
                      className="info_social_icon"
                    />
                    <img
                      src="https://s19.picofile.com/file/8440286118/3.jpg"
                      className="info_social_icon"
                    />
                    <img
                      src="https://s18.picofile.com/file/8440286142/4.jpg"
                      className="info_social_icon"
                    />
                    <img
                      src="https://s19.picofile.com/file/8440286168/5.jpg"
                      className="info_social_icon"
                    />
                    <img
                      src="https://s18.picofile.com/file/8440286200/6.jpg"
                      className="info_social_icon"
                    />
                  </div>
                </dvi>
              </div>
              <div className="col-xs-12 col-sm-12 sol-md-6 col-lg-6 col-xl-6">
                <div className="form_body">
                  <h4>فرم ارتباط با ما</h4>
                  <div className="input_sec_body">
                    <h6 className="input_title">نام و نام خانوادگی</h6>
                    <Input
                      change={(e) => setFullName(e.target.value)}
                      height="45px"
                      direction="rtl"
                      width="100%"
                      value={fullName}
                    />
                  </div>
                  <div className="input_sec_body">
                    <h6 className="input_title">آدرس ایمیل</h6>
                    <Input
                      change={(e) => setEmail(e.target.value)}
                      height="45px"
                      direction="rtl"
                      width="100%"
                      value={email}
                    />
                  </div>
                  <div className="input_sec_body">
                    <h6 className="input_title">متن پیام</h6>
                    <Input
                      change={(e) => textHandler(e)}
                      direction="rtl"
                      height="100px"
                      width="100%"
                      value={text}
                    />
                  </div>
                  <div onClick={sendFormHandler}>
                    <Button
                      boxShadow={sendBtnStyle.boxshadow}
                      background={sendBtnStyle.background}
                      color="white"
                      heigh="50px"
                      width="180px"
                      radius="23px"
                      tooltip={sendBtnStyle.tooltip}
                      tooltiploc="bottom"
                      cursor={sendBtnStyle.cursor}
                    >
                      ارسال
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Fragment>
  );
};
export default Contact;
